module.exports = __webpack_public_path__ + "static/media/msg-security.75aa996c.svg";